import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.less']
})
export class BaseUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
